import { AxiosError, AxiosResponse } from 'axios';
import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import { ApiErrorResponse, ApiResponse } from '@/types/api';
import { api } from '@/utils/api';

import { PlanItemType } from './usePayPlan';

export interface GetPayCouponValidateRequest {
  code: string;
}

interface GetPayCouponValidateResponse {
  expiredAt: string;
  plan: Omit<PlanItemType, 'status'>[];
}

export const getPayCouponValidate = ({ code }: GetPayCouponValidateRequest) => {
  return api.get<ApiResponse<GetPayCouponValidateResponse>>('/pay/coupon', {
    params: { code },
  });
};

const usePayCouponValidate = (
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse<GetPayCouponValidateResponse>>,
    AxiosError<ApiErrorResponse>,
    GetPayCouponValidateRequest
  >,
): UseMutationResult<
  AxiosResponse<ApiResponse<GetPayCouponValidateResponse>>,
  AxiosError<ApiErrorResponse>,
  GetPayCouponValidateRequest
> => {
  return useMutation(getPayCouponValidate, { ...options });
};

export default usePayCouponValidate;
